import { useEffect, useState } from "react";

const navLinks = [
  { id: "hot", label: "头条热帖" },
  { id: "thread", label: "瓜友热议" },
  { id: "forum", label: "版块广场" },
  { id: "faq", label: "吃瓜FAQ" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const base = open
    ? "bg-background-50/95 shadow-soft"
    : scrolled
      ? "bg-background-50/95 shadow-soft"
      : "bg-transparent";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${base}`}
    >
      <div className="mx-auto flex h-[70px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5" aria-label="大瓜网 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-water-flash-line text-xl" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-2xl text-foreground-950">大瓜网</span>
            <span className="mt-0.5 text-[11px] tracking-wide text-foreground-500">
              看瓜也看人 · 观点碰撞场
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#trend"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-100 px-4 py-2 text-sm font-medium text-secondary-800 transition-colors hover:border-secondary-300 hover:bg-secondary-200"
          >
            <i className="ri-fire-line text-base" aria-hidden="true" />
            热搜榜
          </a>
          <a
            href="#thread"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-3-line text-base" aria-hidden="true" />
            我要发言
          </a>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-800 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 md:hidden"
          aria-label="移动端导航"
        >
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#thread"
            onClick={() => setOpen(false)}
            className="mt-2 block rounded-lg bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
          >
            我要发言
          </a>
        </nav>
      )}
    </header>
  );
}